import {
  DownOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, Form, Modal, Select, Tree } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../../utils/auth";
import Loading from "../../common/Loader";
import { responseNotification } from "../../../utils/notify";
import HubLayout from "../Layout";
import _ from "lodash";
import HubHeader from "../Layout/topHeader";
import { debounce } from "lodash";
import { getParamValue } from "../../../utils";
import { useSelector } from "react-redux";
const { Option } = Select;
const { DirectoryTree } = Tree;

const HubCategory = () => {
  const { hubInfo } = useSelector((state) => (state as any)?.authReducer);
  const [type] = useState<string>(hubInfo?.type || "JC_MART");
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState("");
  const [visible, setVisible] = useState(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const history = useHistory();

  const [categoryOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoryId, setCategoryId] = useState<any>();
  const [categoryName, setCategoryName] = useState<any>();
  const [categoryData, setCategoryData] = useState({
    loading: false,
    data: null,
  });

  const route = useParams();
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [limit, setLimit] = useState(16);

  // All Category List For Add Category
  const getCategoriesOptions = useCallback(async () => {
    setCategoriesOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    const res = await axios.get(
      `${encodedUri}/admin/category/parent-by-type?page=${page || 0}&limit=${
        limit || 16
      }` +
        (type ? `&type=${type}` : ``) +
        (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setCategoriesOptions({
      loading: false,
      list: res?.data?.categories?.map((category: { id: any; title: any }) => {
        return {
          value: category?.id,
          label: category?.title,
        };
      }),
    });
  }, [key]);

  useEffect(() => {
    if (key) {
      getCategoriesOptions();
    }
  }, [getCategoriesOptions]);

  useEffect(() => {
    if (type && isModalVisible) {
      getCategoriesOptions();
    }
  }, [getCategoriesOptions, isModalVisible, type]);

  const fetchRef = useRef(0);
  const categorySearchDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getCategoriesOptions();
    };

    return debounce(loadOptions, 800);
  }, [getCategoriesOptions]);

  // Category List By Hub ID
  const getHubCategory = useCallback((getHubId) => {
    if (getHubId) {
      try {
        setCategoryData({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/hub/categories/admin?id=${getHubId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setCategoryData({
                loading: false,
                data: data?.data,
              });
            } else {
              setCategoryData({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setCategoryData({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setCategoryData({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    getHubCategory(hubInfo?.id);
  }, [getHubCategory, route]);

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      category: data.categoryId.map((category, index) => ({
        categoryId: category,
        displayOrder:
          index +
          1 +
          (categoryData?.data?.categories?.[
            categoryData?.data?.categories?.length - 1
          ]?.displayOrder * 1 || 0),
      })),
      hubId: hubInfo?.id,
    };

    await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category-hub`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Category Assigned Successfully", "success");
          getHubCategory(hubInfo.id);
          form.resetFields();
          handleOk();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const onDelete = async (id: any) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category-hub`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          categories: [
            {
              categoryId: id,
            },
          ],
          hubId: hubInfo.id,
          deleted: true,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Category Deleted Successfully", "success");
            getHubCategory(hubInfo.id);
            setVisible(undefined);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setVisible(undefined);
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (visible) {
      setSelectedCategory(undefined);
    }
  }, [selectedCategory, selectedCategory]);

  useEffect(() => {
    setSelectedCategory(undefined);
  }, [visible]);

  const changeOrder = async (pos, node) => {
    let curr;
    let item;

    categoryData?.data?.categories?.find((category, i) => {
      if (category?.category?.id === node?.key) {
        curr = i;
        item = category;
      }
    });

    const formated =
      curr !== pos &&
      _.concat(
        curr < pos
          ? categoryData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(0, pos - 1)
          : categoryData?.data?.categories?.slice(0, pos),
        item,
        curr > pos
          ? categoryData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(pos, categoryData?.data?.categories?.length - 1)
          : categoryData?.data?.categories?.slice(
              pos,
              categoryData?.data?.categories?.length
            )
      )?.map((item, i) => ({
        categoryId: item?.category?.id,
        displayOrder: i + 1,
      }));

    if (formated) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category-hub`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          categories: formated,
          hubId: hubInfo?.id,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            getHubCategory(hubInfo?.id);
            responseNotification("Position Updated Successfully", "success");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  return (
    <React.Fragment>
      <HubLayout hubId={hubInfo?.id as string}>
        <div className="product-list-item-area white-bg">
          <HubHeader
            leftarea={"Category List"}
            rightarea={
              <div className="">
                <Button
                  danger
                  type="primary"
                  icon={<PlusOutlined />}
                  title="Add Category"
                  onClick={showModal}
                >
                  Add Category
                </Button>
              </div>
            }
          />

          <div className="pt-3">
            {categoryData?.loading ? (
              <Loading />
            ) : (
              <div className="product-table-area details-area">
                <DirectoryTree
                  height={600}
                  draggable
                  showLine
                  multiple
                  showIcon={false}
                  switcherIcon={<DownOutlined />}
                  treeData={categoryData?.data?.categories.map((category) => ({
                    title: category?.category?.title,
                    key: category?.category?.id,
                    children: category?.categories?.map((child) => ({
                      title: child?.categories?.title,
                      key: child?.categories?.id,
                      // children: [{ title: "child" }],
                    })),
                  }))}
                  onDrop={(e) => {
                    changeOrder(e.dropPosition, e.dragNode);
                  }}
                  onRightClick={(val) => {
                    setCategoryId(val?.node?.key);
                    setCategoryName(val?.node?.title);
                    setVisible(val?.node?.key);
                  }}
                  onSelect={(val) => {
                    console.log(val);
                    history.push(`categories/${val}`);
                  }}
                  
                />
              </div>
            )}
          </div>
        </div>
      </HubLayout> 

      <Modal
        title="Are you sure to Delete Category?"
        visible={visible}
        onOk={() => {
          handleOk();
          onDelete(categoryId);
        }}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okType={"danger"}
        okText="Delete"
      >
        <div className="alert alert-danger d-flex align-items-center justify-content-between">
          <span className="text-uppercase text-danger">
            Deleting this category may remove the existing sub-categories and
            products under it. Are you sure you want to <b>Delete</b> ?
          </span>
          <ExclamationCircleOutlined
            style={{ fontSize: 56, marginLeft: 10, color: "#f00" }}
          />
        </div>
      </Modal>

      <Modal
        title="Assign Category"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            hasFeedback
            label="Select Category"
            name="categoryId"
            rules={[
              {
                required: true,
                message: "Pleasse Select Minimum One Category!",
              },
            ]}
          >
            {/* <TreeSelect
            showSearch
            treeNodeFilterProp='title'
              allowClear
              dropdownMatchSelectWidth
              maxTagCount={3}
              placeholder="Select Category"
              treeCheckable
              treeData={categoryOptions?.list}
              onSearch={categorySearchDebounce}
              filterTreeNode={true}
            /> */}
            <Select
              disabled={!categoryData?.data ? true : false}
              allowClear
              showSearch
              mode="tags"
              placeholder="Search Category"
              optionFilterProp="children"
              onChange={(val) => setCategoryId(val)}
              onSearch={categorySearchDebounce}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0 ||
                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
              }
              // options={categoryOptions?.list}
            >
              {categoryOptions.list.map((category: any) => (
                <Option value={category?.value}>{category.label}</Option>
              ))}
            </Select>
          </Form.Item>

          <div className="buttons-container mt-3">
            <Button
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => form?.resetFields()}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default HubCategory;
